import { useEffect, useState } from 'react';
import { FLOW_ORG_PAGES } from '../../constants/organization';
import { resolveOrgUserRole } from '../../utils/organization';
import PageSwitcher from '../generic/PageSwitcher';
import Loader from '../loader/Loader';
import AdminUI from './AdminUI';
import NonAdminUI from './NonAdminUI';
import OrganizationInviteProvider from './OrganizationInviteProvider';
import { useTenant } from '../TenantProvider';
import { useUser, useUserDispatch } from '../UserProvider';
import { getUser } from '../../sources/user';

const InitialOrgPage = () => {
    const [orgPageId, setOrgPageId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const user = useUser();
    const dispatchUser = useUserDispatch();
    const tenant = useTenant();

    useEffect(() => {
        // We need to wait for the user to be loaded every time we enter this screen
        // in case the user has been removed from the current tenant's organization
        const fetchCurrentUser = async () => {
            setIsLoading(true);
            const user = await getUser();
            dispatchUser({ type: 'setUser', payload: user });
            setIsLoading(false);
        };

        fetchCurrentUser();
    }, [dispatchUser]);

    useEffect(() => {
        const { isUserAdmin, isTenantInOrg } = resolveOrgUserRole(user, tenant);

        const pageId =
            isUserAdmin && isTenantInOrg
                ? FLOW_ORG_PAGES.flowOrgAdminUI
                : FLOW_ORG_PAGES.flowOrgJoinedUI;

        setOrgPageId(pageId);
    }, [user, tenant]);

    if (isLoading || !orgPageId) {
        return <Loader />;
    }

    return (
        <OrganizationInviteProvider>
            <PageSwitcher
                pages={[
                    {
                        id: FLOW_ORG_PAGES.flowOrgAdminUI,
                        label: 'Organization Settings',
                        parent: null,
                        menu: [
                            {
                                label: 'Current Organization',
                                link: '#organizationDetails',
                                visible: true,
                            },
                            {
                                label: 'Organization Invitations',
                                link: '#organizationInvitations',
                                visible: true,
                            },
                            {
                                label: 'Tenants',
                                link: '#organizationTenants',
                                visible: true,
                            },
                            {
                                label: 'Administrators',
                                link: '#organizationAdministrators',
                                visible: true,
                            },
                            {
                                label: 'Local Runtimes',
                                link: '#localRuntimes',
                                visible: true,
                            },
                        ],
                        component: AdminUI,
                    },
                    {
                        id: FLOW_ORG_PAGES.flowOrgJoinedUI,
                        label: 'Organization Settings',
                        parent: null,
                        menu: null,
                        component: () => <NonAdminUI tenant={tenant} />,
                    },
                ]}
                wrapperSelector="flow-organisation"
                initialPageId={orgPageId}
            />
        </OrganizationInviteProvider>
    );
};

export default InitialOrgPage;
